import { render, staticRenderFns } from "./verificationRecord.vue?vue&type=template&id=70555800&scoped=true&"
import script from "./verificationRecord.vue?vue&type=script&lang=js&"
export * from "./verificationRecord.vue?vue&type=script&lang=js&"
import style0 from "./verificationRecord.vue?vue&type=style&index=0&id=70555800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70555800",
  null
  
)

component.options.__file = "verificationRecord.vue"
export default component.exports